import { Controller, useForm } from 'react-hook-form';
import { useChangePasswordStore } from '@lib/store';
import { Button, Input, Modal } from '@shared/widgets';
import { useEffect } from 'react';

interface IForm {
  currentPassword: string;
  newPassword: string;
  NewPassswordConfirm: string;
}

const DEFAULT_FORM = {
  currentPassword: '',
  newPassword: '',
  NewPassswordConfirm: '',
};

interface IChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ChangePasswordModal = (props: IChangePasswordModalProps) => {
  const { loading, success, change } = useChangePasswordStore();
  const {
    control,
    handleSubmit,
    setError,
    reset,
    formState: { errors },
  } = useForm<IForm>({ mode: 'onChange', defaultValues: DEFAULT_FORM });

  useEffect(() => {
    if (loading || !success) return;
    if (success) {
      props.onConfirm();
    }
  }, [loading, success]);

  const closeHandler = () => {
    reset(DEFAULT_FORM);
    props.onClose();
  };
  const changePasswordHandler = async (data: IForm) => {
    if (data.currentPassword === data.newPassword || data.newPassword !== data.NewPassswordConfirm) {
      setError('root', { message: 'Password incorrect' });
      return;
    }
    await change(data);
    props.onClose();
    reset(DEFAULT_FORM);
  };

  return (
    <Modal title='Change Password' isOpen={props.isOpen} onClose={closeHandler}>
      <form className='flex flex-col gap-4' onSubmit={handleSubmit(changePasswordHandler)}>
        <Controller
          name='currentPassword'
          control={control}
          rules={{ required: 'Mandatory fields' }}
          render={({ field, fieldState: { error } }) => (
            <div className='flex flex-col gap-1'>
              <Input {...field} label='Current Password' type='password' />
              {error?.message && (
                <div className='flex items-baseline gap-1'>
                  <div className='h-[13px] w-[12px] rounded-full bg-[#d0021b] text-center text-xs font-bold text-[#fff]'>!</div>
                  <div className='text-xs font-bold text-[#d0021b] uppercase'>{error?.message}</div>
                </div>
              )}
            </div>
          )}
        />
        <Controller
          name='newPassword'
          control={control}
          rules={{ required: 'Mandatory fields', minLength: { value: 8, message: '8 characters minimum' } }}
          render={({ field, fieldState: { error } }) => (
            <div className='flex flex-col gap-2'>
              <Input {...field} label='New Password' type='password' />
              {error?.message && (
                <div className='flex items-baseline gap-1'>
                  <div className='h-[13px] w-[12px] rounded-full bg-[#d0021b] text-center text-xs font-bold text-[#fff]'>!</div>
                  <div className='text-xs font-bold text-[#d0021b] uppercase'>{error?.message}</div>
                </div>
              )}
            </div>
          )}
        />
        <Controller
          name='NewPassswordConfirm'
          control={control}
          rules={{ required: 'Mandatory fields', minLength: { value: 8, message: '8 characters minimum' } }}
          render={({ field, fieldState: { error } }) => (
            <div className='flex flex-col gap-2'>
              <Input {...field} label='Retype New password' type='password' />
              {error?.message && (
                <div className='flex items-baseline gap-1'>
                  <div className='h-[13px] w-[12px] rounded-full bg-[#d0021b] text-center text-xs font-bold text-[#fff]'>!</div>
                  <div className='text-xs font-bold text-[#d0021b] uppercase'>{error?.message}</div>
                </div>
              )}
            </div>
          )}
        />
        {errors.root?.message && (
          <div className='flex items-baseline gap-2'>
            <div className='h-[13px] w-[12px] rounded-full bg-[#d0021b] text-center text-xs font-bold text-[#fff]'>!</div>
            <div className='text-xs font-bold text-[#d0021b] uppercase'>{errors.root?.message}</div>
          </div>
        )}
        <div className='mt-7 flex gap-4'>
          <Button fullWidth color='outlined' onClick={closeHandler}>
            Cancel
          </Button>
          <Button type='submit' fullWidth isLoading={loading}>
            Save
          </Button>
        </div>
      </form>
    </Modal>
  );
};
